import { Link } from 'react-router-dom'
import textServices from 'services/text-services'
import { SignInDiv } from 'theme/theme'

function SignIn() {
  return (
    <Link
      to="/login"
      className="w-full sm:w-72"
      onClick={() => {
        gtag('event', 'Click', {
          event_category: GTM_EVENT_CATEGORY,
          event_label: 'Inicio de sesión - Email',
          value: 'Email'
        })
      }}
    >
      <SignInDiv>
        {textServices.findByText('start/signin', 'YA TENGO USUARIO')}
      </SignInDiv>
    </Link>
  )
}

export default SignIn
